'use client';

import { Spinner } from '@/app/elements/spinner';
import { useReminder } from '@/hooks/use-reminder';
import type { ReminderModule } from '@/tracking/amplitude/events/general/reminder';
import './styles/@theme';

const REMINDER_ICONS = {
    bell: '/images/bell.png',
    checked: '/images/checked-mark.png'
} as const;

type RemindMeButtonProps = {
    zoneUid: string;
    gameId: string;
    module: ReminderModule;
    gameName: string;
};

export const RemindMeButton: React.FC<RemindMeButtonProps> = ({ zoneUid, gameId, module, gameName }) => {
    const { isSet, isLoading, toggle } = useReminder(zoneUid, gameId, module, gameName);

    const text = isSet ? 'Reminder Set' : 'Remind Me';
    const icon = isSet ? REMINDER_ICONS.checked : REMINDER_ICONS.bell;

    return (
        <button type="button" className="remind-me-button" onClick={toggle} disabled={isLoading} aria-pressed={isSet}>
            {isLoading ? (
                <Spinner />
            ) : (
                <>
                    <img className="remind-me-icon" src={icon} alt="" width={18} height={18} />
                    {text}
                </>
            )}
        </button>
    );
};
